<div class="wrapper" [ngClass]="{ hideBar: !stateName }">
    <div class="container">
        <div class="main-nav">
            <div *ngIf="stateName" class="for-educators-notice">For {{ stateName }} Educators</div>
            <div class="buttons-group-wrapper">
                <!--Subjects-->
                <app-subjects-dropdown
                    [subjects]="subjects"
                    (subjectSelected)="navigateTo($event)"
                    (toggleSubjectPanel)="onTogglePanel($event)"
                ></app-subjects-dropdown>

                <!--Grades-->
                <app-grades-dropdown
                    [grades]="gradeBands"
                    (gradeSelected)="navigateTo($event)"
                    (toggleGradePanel)="onTogglePanel($event)"
                ></app-grades-dropdown>

                <!--Standards Button-->
                <button
                    class="selenium-navigation-browse-standards"
                    (click)="router.navigate(['/standards/0/'])"
                >
                    Standards
                </button>

                <!--For Students Link-->
                <a
                    class="for-students py-2 px-7"
                    href="#"
                    (click)="openStudentExperienceInNewTab(); $event.preventDefault()"
                    rel="noopener noreferrer"
                >
                    For Students
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </div>
        </div>
    </div>
</div>
